import React, { useEffect, useRef, useState } from 'react';

import { usePostLogout } from 'apis/handler/auth/usePostLogout';
import { Button } from 'components/ui/button';
import { useRouteChangeHandler } from 'shared/hooks';
import { useInfoStore } from 'store/useInfoStore';

import { ReactComponent as Arrow } from '../../../assets/icons/ic_arrow_round.svg';

function UserDropdownMenu({ name }: { name: string }) {
  const logoutRef = useRef<HTMLDivElement>(null);
  const logout2xlRef = useRef<HTMLDivElement>(null);
  const [isLogoutOpen, setIsLogoutOpen] = useState(false);

  const { resetInfo } = useInfoStore();

  const { handleRouteChange } = useRouteChangeHandler();
  const { mutate: logoutMutation } = usePostLogout({
    onSuccess: () => {
      handleRouteChange('/');
      resetInfo();
      setIsLogoutOpen(false);
    },

    onError: () => {
      handleRouteChange('/');
      resetInfo();
      setIsLogoutOpen(false);
    },
  });

  useEffect(() => {
    const handleOutsideClick = (event: MouseEvent) => {
      if (
        isLogoutOpen &&
        !(logoutRef.current?.contains(event.target as Node) || logout2xlRef.current?.contains(event.target as Node))
      ) {
        setIsLogoutOpen(false); // 바깥 클릭 시 닫기
      }
    };

    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isLogoutOpen]);

  return (
    <div className="relative w-[117px]" ref={logoutRef}>
      <Button
        className="flex h-[37px] w-full cursor-pointer items-center justify-center gap-x-1 rounded-full bg-primary px-4 py-2 text-c2 font-medium text-white"
        onClick={() => {
          setIsLogoutOpen(!isLogoutOpen);
        }}
      >
        <span>{name}</span>
        <Arrow width={14} height={14} />
      </Button>

      {isLogoutOpen && (
        <div>
          <Button
            className="absolute top-[-2px] my-12 h-[37px] w-full rounded-full bg-white text-c2 font-medium text-black shadow-abmodal"
            onClick={() => handleRouteChange('/my')}
          >
            My Page
          </Button>

          <Button
            className="absolute top-[84px] my-2 h-[37px] w-full rounded-full bg-white text-c2 font-medium text-black shadow-abmodal"
            onClick={() => logoutMutation()}
          >
            Log out
          </Button>
        </div>
      )}
    </div>
  );
}

export default UserDropdownMenu;
